import React from "react";

const SvgWineBottle = props => (
  <svg data-name="Layer 1" viewBox="0 0 215 215" {...props}>
    <path
      d="M124.19 72.83a38.26 38.26 0 01-7.47-23.23l-.08-36.76H98.21l.07 36.76a38.26 38.26 0 01-7.47 23.23c-7.23 10.08-9.52 18.55-9.52 34.72v94.61h52.42v-94.61c0-16.17-2.29-24.64-9.52-34.72zM112.7 16.77l.1 32.6h-10.6l-.06-32.6zm13.77 147.79H88.79v-48.68h37.68z"
      fill="currentColor"
    />
  </svg>
);

export default SvgWineBottle;